import { Injectable } from "@angular/core";
import { filter, Observable } from "rxjs";

import { LiveUpdateConnections } from "./live-update-connections.service";

import { SubmissionUpdate } from "../models/submission-update.model";
import { LiveUpdateBaseService } from "./live-update-base.service";
import { EFileStatusUpdate } from "../models/efile-status-update.model";
import { AuthResultBe } from "../models/auth-result-be.model";

@Injectable()
export class LiveUpdateService extends LiveUpdateBaseService  {

    constructor(liveUpdateConnections: LiveUpdateConnections) {
        super("/updates", liveUpdateConnections);
    }

    listenForEFileUpdates() : Observable<SubmissionUpdate>{
        return this.connector.listenFor<SubmissionUpdate>("EFileUpdateAsync", this.subscriptionId);
    }

    listenForSubmissionUpdates() : Observable<SubmissionUpdate>{
        return this.connector.listenFor<SubmissionUpdate>("SubmissionUpdateAsync", this.subscriptionId);
    }

    listenForDownloadAllSuccess() : Observable<string>{
        return this.connector.listenFor<string>("DownloadAllUriAsync", this.subscriptionId);
    }

    listenForDownloadAllFail() : Observable<string[]>{
        return this.connector.listenFor<string[]>("DownloadAllErrorAsync", this.subscriptionId);
    }

    listenForEFileStatusUpdates() : Observable<EFileStatusUpdate>{
        return this.connector.listenFor<EFileStatusUpdate>("EFileStatusUpdateAsync", this.subscriptionId);
    }

    listenForAuthResultUpdatesBE(requestId: string) : Observable<AuthResultBe>{
        return this.connector.listenFor<AuthResultBe>("AuthenticationResultBEAsync", this.subscriptionId).pipe(
            filter(result => result.requestId === requestId));
    }
}